import { UserService } from './../../services/user.service';
import { Component, OnInit, Input, Output, EventEmitter, HostListener, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
    selector: 'app-uploadfile',
    templateUrl: './uploadfile.component.html'
})
export class UploadFileComponent implements OnInit {

    errors = [];
    dragAreaClass = 'dragarea';
    files: any[] = [];
    @Input() projectId = 0;
    @Input() sectionId = 0;
    @Input() fileExt = 'JPG, GIF, PNG';
    @Input() maxFiles = 5;
    @Input() maxSize = 5; // 5MB
    @Output() uploadStatus = new EventEmitter();

    constructor(private userService: UserService) { }

    ngOnInit() {
    }

    onFileChange(event) {
        this.files = event.target.files;
        this.saveFiles(this.files);
    }

    saveFiles(files) {
        this.errors = []; // Clear error
        // Validate file size and allowed extensions
        this.isValidFiles(files);
        if (files.length > 0 && (this.errors.length === 0)) {
            this.uploadStatus.emit({ficheros: this.files});
        } else {
            this.files = [];
        }
    }

    private isValidFiles(files) {
        // Check Number of files
        if (files.length > this.maxFiles) {
            this.errors.push('Error: At a time you can upload only ' + this.maxFiles + ' files');
        }
        this.isValidFileExtension(files);
    }

    private isValidFileExtension(files) {
        // Make array of file extensions
        let extensions = (this.fileExt.split(','))
        .map(function (x) { return x.toLocaleUpperCase().trim() });
        for (var i = 0; i < files.length; i++) {
            // Get file extension
            let ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
            // Check the extension exists
            let exists = extensions.includes(ext);
            if (!exists) {
                this.errors.push('Error (Extension): ' + files[i].name);
            }
                // Check file size
                this.isValidFileSize(files[i]);
        }
    }

    private isValidFileSize(file) {
        let fileSizeinMB = file.size / (1024 * 1000);
        let size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
        if (size > this.maxSize) {
            this.errors.push('Error (File Size): ' + file.name + ': exceed file size limit of ' + this.maxSize + 'MB ( ' + size + 'MB )');
        }
    }

    public QuitarImagen() {
        this.files = [];
        this.uploadStatus.emit({ficheros: this.files});
    }
}